import React from 'react';
import { connect } from 'react-redux';
import LoadingStatusModal from './LoadingStatusModal';

interface Props {
    calculateZoneClassication: boolean;
}

class CalculateZoneClassificationModal extends React.Component<Props> {
  render() {
    return (
      <LoadingStatusModal
        id="zone-recalculation"
        visible={this.props.calculateZoneClassication}
        title="Zone classification calculation"
        message="Refreshing roof zone classification based on the latest project settings."
        hint="This may take a moment while we update the design data used by the rest of the workflow."
      />
    );
  }
}

const mapStateToProps = (appState: appState) => ({
    calculateZoneClassication: appState.settings.calculateZoneClassication,
});

export default connect(mapStateToProps)(CalculateZoneClassificationModal);

